import React, { useState, useEffect, useMemo } from "react";
import { PaginationTypes } from "@Shared/Pagination-Types";
import { usePeople } from "../usePeople";
import { usePeopleStore } from "../../../stores/use-people-store";
import { useOpticsStore } from "../../../stores/use-optics-store";
import useCosmosFields from "../../../hooks/use-cosmos-fields";
import CustomEmptyState from "../../../components/empty-state/CustomEmptyState";
import { CUSTOM_EMPTY_STATE_KEY } from "../../../components/empty-state/custom-templates";
import People from "../widget/People";

function ManualPeople({ isEdit, mode }) {
  const { config, selectedTab } = usePeopleStore((state) => ({
    config: state.data.config,
    selectedTab: state.getSelectedTab(),
  }));

  const isCosmosInstalled = useOpticsStore((state) => state.isCosmosInstalled);
  const { fields } = useCosmosFields();

  const { tabs, pagination, titleFieldId, footerFieldId } = config || {};

  const limit = isEdit ? 999 : Number(tabs?.[selectedTab]?.limit || 4);
  const manuallyPicked = tabs?.[selectedTab]?.manuallyPicked || [];

  const userQueries = usePeople(manuallyPicked, {
    fetchWithCosmosData: true,
    isCosmosInstalled,
    fields,
    titleFieldId,
    footerFieldId,
  });

  const userResults = useMemo(
    () =>
      userQueries
        .map((q) => q.data)
        .filter((q) => q && !q.isPlaceholder && !q.isNew),
    [userQueries]
  );

  const [page, setPage] = useState(0);
  const isCarousel = pagination === PaginationTypes.CAROUSEL;
  const startIndex = isCarousel ? page * Number(limit) : 0;
  const endIndex = page * Number(limit) + Number(limit);
  const paginatedUsers = userResults.slice(startIndex, endIndex);

  const queryPagination = {
    disabled: isEdit || pagination === PaginationTypes.NONE,
    hasNextPage: endIndex < userResults.length,
    hasPrevPage: page > 0,
    onNext: () => {
      if (endIndex < userResults.length) setPage((prev) => prev + 1);
    },
    onPrev: () => {
      if (page > 0) setPage((prev) => prev - 1);
    },
    page,
    setPage,
  };

  useEffect(() => setPage(0), [pagination]);

  if (!paginatedUsers.length) {
    return (
      <CustomEmptyState templateKey={CUSTOM_EMPTY_STATE_KEY.PEOPLE_SETUP} />
    );
  }

  const paginationData = { [isCarousel ? page : 0]: paginatedUsers };

  return (
    <People
      data={paginationData}
      queryPagination={queryPagination}
      isCosmosInstalled={isCosmosInstalled}
      mode={mode}
    />
  );
}

export default ManualPeople;
